import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { SvgIcon } from '@shared/components/svg-icon/svg-icon';
import { type DynamicAction } from '@shared/registry';

import { type InfoBannerConfig } from './info-banner.types';

@Component({
  selector: 'app-info-banner',
  templateUrl: './info-banner.html',
  imports: [SvgIcon],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoBanner {
  readonly config = input.required<InfoBannerConfig>();
  readonly action = output<DynamicAction>();

  protected onButtonClick(): void {
    const actionConfig = this.config().button?.action;
    if (actionConfig) {
      this.action.emit(actionConfig);
    }
  }
}
